module.exports = require("@swa-ui/application/src/Maintenance/MaintenanceMessage.module.scss");